<script setup lang="ts">
import { RouterLink } from 'vue-router'
</script>

<template>
  <div class="empty-state">
    <p class="empty-state__title is-size-4">Page not found</p>
    <p class="mb-4">That route does not exist.</p>
    <RouterLink class="button is-primary" to="/">Back to the dashboard</RouterLink>
  </div>
</template>
